export enum LocationStaleTimeEnum {
  GetLocation = 60000,
  SearchLocationMap = 60000,
}
